import React from 'react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import { DialogIllustration } from 'components/Dialog'
import { observer } from 'mobx-react'
import { pluralize } from '../../../utils/pluralization-util'
import styles from './FileNameMismatch.sass'
import { FileNameMismatchViewModel } from './FileNameMismatchViewModel'
import Button from 'components/Button'

interface Props {
  vm: FileNameMismatchViewModel
}

export const FileNameMismatchModal = observer(({ vm }: Props) => {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton closeButtonDataTest="close-upload" />

      <ModalSheetContent>
        <ModalSheetContentBlock>
          <DialogIllustration
            src={require('assets/images/img_remove-collaborator.svg')}
            alt="Warning illustration"
          />
          <div className={styles.titleContainer}>
            <ModalSheetContentTitle>
              File {pluralize('name', vm.fileCount)}{' '}
              {vm.fileCount === 1 ? 'does' : 'do'} not contain the{' '}
              {vm.clientCount === 1 ? "client's" : "clients'"}{' '}
              {pluralize('name', vm.clientCount)}
            </ModalSheetContentTitle>
          </div>

          <ModalSheetContentDescription>
            The following {pluralize('file', vm.fileCount)}{' '}
            {vm.fileCount === 1 ? 'does' : 'do'} not contain the{' '}
            {pluralize('name', vm.clientCount)} of the{' '}
            {pluralize('client', vm.clientCount)} on the job:
            <span className={styles.clientNames}> {vm.clientNamesList}</span>
            <div className={styles.fileList}>
              {vm.filesList.map((fileName, index) => (
                <div key={index}>
                  {fileName}
                  {index < vm.filesList.length - 1 && <br />}
                </div>
              ))}
            </div>
            <span>
              Please take a moment to review and correct the{' '}
              {pluralize('file', vm.fileCount)} before uploading to the job.
            </span>
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button onClick={vm.close} type="default" dataTest="close-upload">
            Close
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
